
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiSog as ObiSogElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-sog.js';
 
 
 

 
 export const ObiSog = createComponent({
   react: React,
   tagName: 'obi-sog',
   elementClass: ObiSogElement,
   events: {
     
   }
  });
 
 